<section fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap="16px">
  <figure fxFlex="1/2" [style.padding]="padding|async">
    <figcaption *ngIf="employmentType === type.land">
      <h3>BORROWER</h3>
      <ul>
        <li>Passport</li>
        <li>Electric Bill (latest + proof of residence if not
          in own name)
        </li>
        <li>Employment contract with POEA stamp</li>
        <li>Working Visa</li>
        <li>OEC</li>
        <li>Airline Ticket</li>
      </ul>
    </figcaption>

     <figcaption *ngIf="employmentType === type.sea">
      <h3>BORROWER</h3>
      <ul>
        <li>Passport</li>
        <li>Electric Bill</li>
        <li>Employment contract with POEA stamp</li>
        <li>Seaman's Book</li>
        <li>SRN or POEA E-Registration Form</li>
        <li>Airline Ticket</li>
      </ul>
    </figcaption>
  </figure>
  <figure fxFlex="1/2" [style.padding]="padding|async">
    <h3>CO-MAKER</h3>
    <ul>
      <li>Original Electric Bill of Phil. Address</li>
      <li>1 valid primary ID</li>
      <li>Proof of relationship (Birth Certificate if single, Marriage Certificate if married)</li>
      <li>Tax Identification Number (TIN) or SSS number</li>
    </ul>
  </figure>
</section>
